module.exports = __webpack_public_path__ + "app/assets/images/man4-d0256b62a6e021d650bb061bd1276c2d.jpg";